import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";
import { SidebarProvider, useSidebar } from "@/components/sidebar-context";
import { Sidebar } from "@/components/sidebar";
import { Header } from "@/components/header";
import { cn } from "@alkana/ui/utils";

export const Route = createFileRoute("/$locale/_dashboard")({
  component: DashboardLayout,
});

function DashboardContent() {
  const { isOpen } = useSidebar();

  return (
    <div
      className={cn(
        "pb-8 transition-all duration-300",
        isOpen ? "md:ml-[240px]" : "md:ml-[70px]",
      )}
    >
      <Header />
      <main className="px-6">
        <Outlet />
      </main>
    </div>
  );
}

function DashboardLayout() {
  const { user, isLoading } = useAuth();
  const { locale } = Route.useParams();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    window.location.href = `/${locale}/sign-in`;
    return null;
  }

  return (
    <SidebarProvider>
      <Sidebar />
      <DashboardContent />
    </SidebarProvider>
  );
}
